import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "newCust" }

import { searchFormConfig } from "./config/search.config";
import { contentTableConfig } from "./config/content.config";
import PageSearch from "@/components/PageSearch.vue";
import { usePageSearch } from "@/hooks/userPageSearch";
import { toDay } from "@/utils/date-format";
import { reactive, ref } from "vue";
import { usePageModal } from "@/hooks/usePageModal";
import { modalConfig } from './config/modal.config'
import { modalConfigChannel } from './config/modal.config.channel'
import { modalConfigBatchUpdate } from './config/modal.config.batchUpdate'
import { editPageData, getListData } from "@/service/main/system";
import { ElMessage } from "element-plus/es";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewCust',
  setup(__props) {

let query = {}
const pageInfo = ref({ pageNo: 1, pageSize: 10 })
const queryParam = {
  createdTime: [toDay(), toDay()],
  ...query,
  pageNo: pageInfo.value.pageNo,
  pageSize: pageInfo.value.pageSize
}
const resetCb = () => {
  return queryParam
}
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(resetCb);

const dialogTableVisible = ref(false)
const gridData = ref({})
const dialogPeerStatusVisible = ref(false)
const handleViewDetail = (obj: number)=> {
    dialogTableVisible.value = true;
    gridData.value = obj
}
const handlePeerStatus = (row: any)=> {
  row.id = row.serialNumber
  handleEditData(row)
}

const modalTitle = ref('')
const otherInfo = reactive({
})
const editCb = (item: any) => {
  modalTitle.value = '修改企业微信客户状态'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  null,
  editCb
)

const otherInfoChannel = reactive({
})
const modalTitleBatchUpdate = ref('')
const [pageModalRefChannel, defaultInfoChannel, handleNewDataChannel, handleEditDataChannel] = usePageModal(
  null,
  editCb
)

const otherInfoBatchUpdate = reactive({
})
const [pageModalRefBatchUpdate, defaultInfoBatchUpdate, handleNewDataBatchUpdate, handleEditDataBatchUpdate] = usePageModal()

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find((item) => item.field === 'mainBody')
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.id }
  })
}

let customCodes: Array<number> = []
let serialNumbers: string
let createUser: string
const handleSlectionChange = (value: any[]) => {
  customCodes = []
  serialNumbers = ""
  createUser = ""
  for (const row of value) {
    customCodes.push(row.customCode)
    serialNumbers += (row.serialNumber + ", ")
    if (row.createUser != null) {
      createUser += (row.createUser + ", ")
    }
  }
  serialNumbers = serialNumbers.substring(0, serialNumbers.length-2);
  createUser = createUser.substring(0, createUser.lastIndexOf(','));
}
const handleBatchUpdateChannelBtnClick = ()=> {
  if (customCodes.length == 0) {
    ElMessage({
      message: '请勾选修改的数据',
      type: 'warning'
    })
    return
  }

  defaultInfoBatchUpdate.value = {serialNumbers: serialNumbers, createUser: createUser}
  modalTitleBatchUpdate.value = '批量更新开单渠道'
  pageModalRefBatchUpdate.value.dialogVisible = true
  pageModalRefBatchUpdate.value.isBatch = true
}
const handleUpdateBatchData = async (formData: any) => {
  try {
    const formData2 = ref<any>({})
    await editPageData('/main/newCust/batch/update', {
      ...formData,
      customCodes: customCodes
    })
    debugger
    store.dispatch('system/getPageListAction', {
      pageName: 'newCust',
      queryInfo: store.state.system.queryInfo
    })
    pageModalRefBatchUpdate.value.confirmLoading = false
    pageModalRefBatchUpdate.value.dialogVisible = false
  } finally {
    pageModalRefBatchUpdate.value.confirmLoading = false
  }
}

const handleChannel = (row: any)=> {
  row.id = row.serialNumber
  handleEditDataChannel(row)
}
getCompanyList()

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "newCust",
        onBatchUpdateChannelClick: handleBatchUpdateChannelBtnClick,
        onSelectionChange: handleSlectionChange
      }, {
        channel: _withCtx((scope) => [
          (scope.row.channel == null)
            ? (_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                type: "warning",
                href: "javascript:;",
                onClick: ($event: any) => (handleChannel(scope.row)),
                icon: "el-icon-edit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("未选择")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(scope.row.channel), 1)
              ], 64))
        ]),
        peerStatus: _withCtx((scope) => [
          (scope.row.peerStatus == 0)
            ? (_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                type: "warning",
                href: "javascript:;",
                onClick: ($event: any) => (handlePeerStatus(scope.row)),
                icon: "el-icon-edit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("未标注")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(scope.row.peerStatus), 1)
              ], 64))
        ]),
        exist: _withCtx((scope) => [
          (scope.row.exist == 1)
            ? (_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                type: "warning",
                href: "javascript:;",
                onClick: ($event: any) => (handleViewDetail(scope.row.infoList))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("是【查看详情】")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" 否 ")
              ], 64))
        ]),
        _: 1
      }, 8, ["contentTableConfig"]),
      _createVNode(_component_PageModal, {
        ref_key: "pageModalRef",
        ref: pageModalRef,
        defaultInfo: _unref(defaultInfo),
        modalConfig: _unref(modalConfig),
        title: modalTitle.value,
        pageName: "newCust",
        otherInfo: otherInfo
      }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"]),
      _createVNode(_component_PageModal, {
        ref_key: "pageModalRefChannel",
        ref: pageModalRefChannel,
        defaultInfo: _unref(defaultInfoChannel),
        modalConfig: _unref(modalConfigChannel),
        title: modalTitle.value,
        pageName: "newCust",
        otherInfo: otherInfoChannel
      }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"]),
      _createVNode(_component_PageModal, {
        ref_key: "pageModalRefBatchUpdate",
        ref: pageModalRefBatchUpdate,
        defaultInfo: _unref(defaultInfoBatchUpdate),
        modalConfig: _unref(modalConfigBatchUpdate),
        title: modalTitleBatchUpdate.value,
        pageName: "newCust",
        otherInfo: otherInfoBatchUpdate,
        onUpdateBatchData: handleUpdateBatchData
      }, null, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogTableVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogTableVisible).value = $event)),
      title: "查看重复!"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: gridData.value,
          stripe: "true",
          border: "true",
          "header-cell-style": {background:'#eef1f6',color:'#606266'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "serialNumber",
              label: "序号"
            }),
            _createVNode(_component_el_table_column, {
              property: "customerUserId",
              label: "微信编码"
            }),
            _createVNode(_component_el_table_column, {
              property: "employeeUserId",
              label: "工作号"
            }),
            _createVNode(_component_el_table_column, {
              property: "employeeName",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, {
              property: "departmentName",
              label: "所在部门"
            }),
            _createVNode(_component_el_table_column, {
              property: "addTime",
              label: "录入时间"
            }),
            _createVNode(_component_el_table_column, {
              property: "company",
              label: "所属主体"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})